// extracted by mini-css-extract-plugin
module.exports = {"heatMap":"HeatMap_heatMap__1mIm4"};